//configuracion personalizada
//MUGWHITE designer
//carga random para los productos en las colecciones
/*
archivos nexus:
theme.liquid (script después del body) 
product-list.liquid (añadimos class jsblockrm)  class="resource-list__item jsblockrm"
resource-list.liquid (añadimos | append: ' js-random-block' ) assign resource_list_classes = 'resource-list--grid' | append: ' js-random-block' 
base.css (añadimos los estilos al inicio del archivo)
*/
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.resource-list--grid');

  // Shuffle SOLO una vez
  sections.forEach(section => {
    const items = Array.from(section.querySelectorAll('.jsblockrm'));
    if (!items.length) return;

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach(item => section.appendChild(item));
  });

  // Animar por scroll SOLO UNA VEZ
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const section = entry.target;

        // ya animada → no repetir
        if (section.dataset.animated === 'true') return;

        const items = section.querySelectorAll('.jsblockrm');

        items.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('isjs-visible');
          }, index * 120);
        });

        // marcar como animada
        section.dataset.animated = 'true';

        // dejar de observar (clave para evitar recarga al focus)
        observer.unobserve(section);
      });
    },
    {
      threshold: 0.1, root:null,
      rootMargin: '0px 0px 100px 0px'
    }
  );

  sections.forEach(section => observer.observe(section));
});
